export const MOBILE_WIDTH = 600;
export const MIN_NAV_LIST_WIDTH = 1000;
export const MAX_TITLE_LENGTH = 150;
export const API_URL = 'https://render-backend-kr7j.onrender.com/api/webScrape/tumblr/';